import { type PaymentDetails } from '@koala/sdk';
import { type IStoredValue } from '@/types/paymentInfo';
import type { CardDetails } from '@/types/toast';

const paymentActions = {
  CREDIT_CARD_TRANSACTION_ID_GET: '/koala/payment/CREDIT_CARD_TRANSACTION_ID_GET',

  // Stored Value
  DIGITAL_WALLET_TOGGLE: '/koala/payment/DIGITAL_WALLET_TOGGLE',
  DIGITAL_WALLET_WARNING_SET: '/koala/payment/DIGITAL_WALLET_WARNING_SET',
  STORED_VALUE_CLEAR: '/koala/payment/STORED_VALUE_CLEAR',
  STORED_VALUE_SET: '/koala/payment/STORED_VALUE_SET',
  STORED_VALUE_ERROR: '/koala/payment/STORED_VALUE_ERROR',

  BILLING_ACCOUNT_SET: '/koala/payment/BILLING_ACCOUNT_SET',
  CREDIT_CARD_SET: '/koala/payment/CREDIT_CARD_SET',
  PAY_IN_STORE_SET: '/koala/payment/PAY_IN_STORE_SET',

  PAYMENT_TYPE_RESET: '/koala/payment/PAYMENT_TYPE_RESET',

  TOAST_PAYMENT_INITIALIZE: '/koala/payment/TOAST_INITIALIZE',
  TOAST_PAYMENT_CREATE: '/koala/payment/TOAST_PAYMENT_CREATE',
  TOAST_PAYMENT_VALIDATE: '/koala/payment/TOAST_PAYMENT_VALIDATE',
  TOAST_PAYMENT_ERROR: '/koala/payment/TOAST_PAYMENT_ERROR',

  // Credit card exchanges
  creditCardTransactionIdGet: (creditCard: PaymentDetails) => ({
    type: paymentActions.CREDIT_CARD_TRANSACTION_ID_GET,
    creditCard,
  }),

  // Set payment types
  billingAccountSet: (savedAccountId: string) => ({
    type: paymentActions.BILLING_ACCOUNT_SET,
    savedAccountId,
  }),
  creditCardSet: (creditCard: PaymentDetails) => ({
    type: paymentActions.CREDIT_CARD_SET,
    creditCard,
  }),
  payInStoreSet: () => ({
    type: paymentActions.PAY_IN_STORE_SET,
  }),
  digitalWalletToggle: (selectedDigitalWallet: string) => ({
    type: paymentActions.DIGITAL_WALLET_TOGGLE,
    selectedDigitalWallet: selectedDigitalWallet,
  }),
  digitalWalletWarningSet: (hasWarning: boolean) => ({
    type: paymentActions.DIGITAL_WALLET_WARNING_SET,
    hasWarning,
  }),

  // Reset paymentType
  paymentTypeReset: () => ({
    type: paymentActions.PAYMENT_TYPE_RESET,
  }),

  // Stored Value
  storedValueSet: (storedValue: IStoredValue) => ({
    type: paymentActions.STORED_VALUE_SET,
    storedValue,
  }),

  storedValueError: (message: string | null | undefined) => ({
    type: paymentActions.STORED_VALUE_ERROR,
    message,
  }),
  storedValueClear: () => ({
    type: paymentActions.STORED_VALUE_CLEAR,
  }),

  // Toast
  toastPaymentInitialize: (initialized: boolean) => ({
    type: paymentActions.TOAST_PAYMENT_INITIALIZE,
    initialized,
  }),
  toastPaymentCreate: (paymentIntentId: string, card: CardDetails) => ({
    type: paymentActions.TOAST_PAYMENT_CREATE,
    paymentIntentId,
    card,
  }),
  toastPaymentError: (message: string) => ({
    type: paymentActions.TOAST_PAYMENT_ERROR,
    message,
  }),
  toastPaymentValidate: (isValid: boolean, selectedDigitalWallet?: string | null) => ({
    type: paymentActions.TOAST_PAYMENT_VALIDATE,
    isValid,
    selectedDigitalWallet,
  }),
};

export default paymentActions;
